import {makeAutoObservable} from "mobx";
import BrandingTemplateAgent from "../agent/branding-template-agent";
import {RequestBody} from "../../entity/core/request-body";
import {BrandingTemplate} from "../../entity/model/branding-template";
import {BrandingTemplateRequest} from "../../entity/model/branding-template-request";

export default class BrandingTemplateStore {
  brandingTemplateAgent: BrandingTemplateAgent;
  brandingTemplates: BrandingTemplateRequest[] = [];

  constructor(brandingTemplateAgent: BrandingTemplateAgent) {
    makeAutoObservable(this);
    this.brandingTemplateAgent = brandingTemplateAgent;
  }

  createBrandingTemplate = async (organizationId: string, requestBody: RequestBody): Promise<BrandingTemplateRequest | string> => {
    try {
      return await this.brandingTemplateAgent.createBrandingTemplate(organizationId, requestBody);
    } catch (error: any) {
      console.error('Error occurred while creating the branding template', error);
      return 'Error occurred while creating the branding template !!';
    }
  }

  loadBrandingTemplates = async (organizationId: string): Promise<void> => {
    try {
      this.brandingTemplates = await this.brandingTemplateAgent.getBrandingTemplates(organizationId);
    } catch (error: any) {
      console.error('Error occurred while fetching the branding templates', error);
    }
  }

  getBrandingTemplates = (): BrandingTemplateRequest[] => {
    return this.brandingTemplates;
  }
} 